// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"8807b0a7","319":"c49618eb","433":"115ddbc2","438":"e4ef7c05","516":"e82c68d4","979":"1db5f9df","991":"56d7d91a"}[chunkId] + ".chunk.js";
};